{
  "version": 1,
  "asset_id": "f7f97299-2f48-4f67-93a0-0da856d0e16d",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/f7f97299-2f48-4f67-93a0-0da856d0e16d/sleeve-amateur-3.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/f7f97299-2f48-4f67-93a0-0da856d0e16d/sleeve-amateur-3.webp",
  "original_filename": "sleeve-amateur-3.webp",
  "size": 67604,
  "content_type": "image/webp",
  "created_at": "2026-08-15T18:28:58Z"
}
